import React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { makeStyles } from '@mui/styles';
import Icon from "@mui/material/Icon";
import clsx from 'clsx';
import {useHistory} from "react-router-dom";

const useStyles = makeStyles(theme => ({
    root: {},
    board: {
        cursor: 'pointer',
        transitionProperty: 'box-shadow border-color',
        transitionDuration: '0.5s',
        transitionTimingFunction: '0.25s'
    },
    newBoard: {}
}));

export default function Home(props) {

    const classes = useStyles(props);

    const history = useHistory();

    const handleCustomForm = () => {

        history.push(`/form`);

    }

    return <>

        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>

            <Typography typography="h2" textAlign="center">Create a Form</Typography>

            <div
                initial="hidden"
                animate="show"
                className="flex flex-wrap w-full justify-center py-32 px-16"
            >
                <div className="w-224 h-224 p-16">
                    <Paper
                        className={clsx(
                            classes.board,
                            classes.newBoard,
                            'flex flex-col items-center justify-center w-full h-full rounded-16 py-24'
                        )}
                        elevation={3}
                        onClick={e => handleCustomForm(e, 'script')}
                        role="button"
                        tabIndex={0}
                    >
                        <Icon className="text-56" color="action">
                            add
                        </Icon>
                        <Typography className="text-18 font-medium text-center pt-16 px-32" color="inherit">
                            Start from <br/> Scratch
                        </Typography>
                        <p>A blank slate is all you need</p>
                    </Paper>
                </div>
            </div>

        </Container>

    </>;
}